//ChooseColor

import React from "react";
import "./styles.css";
import SingleChooseColor from "./SingleChooseColor";
export default (props) => {
  return (
    <>
      <div className="choose-color">
        <SingleChooseColor
          color={props.color[0]}
          colorClick={props.colorClick}
        />
        <SingleChooseColor
          color={props.color[1]}
          colorClick={props.colorClick}
        />
        <SingleChooseColor
          color={props.color[2]}
          colorClick={props.colorClick}
        />
        <SingleChooseColor
          color={props.color[3]}
          colorClick={props.colorClick}
        />
      </div>
    </>
  );
};

// Loading;
